import { FeatureFlag } from '../FeatureFlag';

export const enableCodeEditorTagTree = new FeatureFlag({
    key: 'enable-code-editor-tag-tree',
    createdOn: '2026-06-03',
    defaultValue: false,
});
